import * as actionTypes from "../actions/types"

const PANEL_STORAGE_KEY = "importantNotificationsPanelOpen"

// Read initial state from localStorage
const getInitialPanelState = () => {
  try {
    const stored = localStorage.getItem(PANEL_STORAGE_KEY)
    return stored === "true"
  } catch (e) {
    return false
  }
}

const initialState = {
  importantNotificationsPanelOpen: getInitialPanelState()
}

export default function ui(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_IMPORTANT_NOTIFICATIONS_PANEL_OPEN: {
      const isOpen = action.payload

      // Persist to localStorage
      try {
        localStorage.setItem(PANEL_STORAGE_KEY, isOpen ? "true" : "false")
      } catch (e) {
        // localStorage not available, ignore
      }

      return {
        ...state,
        importantNotificationsPanelOpen: isOpen
      }
    }
    default:
      return state
  }
}

// Selectors
export const getImportantNotificationsPanelOpen = state => state.importantNotificationsPanelOpen
